











































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import TabComponent from "@/components/layout/TabComponent.vue";
import ReportHistoriesComponent from "@/components/pages/reports/ReportHistoriesComponent.vue";
import RegularReportComponent from "@/components/pages/reports/RegularReportComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { deleteStoreReportApi } from "@/typescript/api_client/emesh_api/reports/store_report_api";
import { storeMenus } from "@/config/store_menus";
import { getRoutePath } from "@/router/routes";

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    TabComponent,
    ReportHistoriesComponent,
    RegularReportComponent,
    ButtonComponent,
    ConfirmDialogComponent,
    FooterComponent
  }
})
export default class ReportsShowPage extends Vue {
  reportHistoriesTab: string = "レポート履歴一覧";
  regularReportTab: string = "定期レポート設定一覧";

  tabs: { name: string }[] = [
    { name: this.reportHistoriesTab },
    { name: this.regularReportTab }
  ];
  activeTabName: string = this.reportHistoriesTab;

  isSensorDelete: boolean = false;
  deleteRegularReportNo: number | undefined = undefined;

  created() {
    this.$store.commit("setActiveId", {
      activeId: storeMenus().find(m => m.pageName === "ReportsPage")?.id
    });
    const queries = this.$route.query;
    if ("type" in queries && queries.type === "reqular") {
      this.activeTabName = this.regularReportTab;
    }
  }

  setActiveTabName(tabName: string): void {
    this.activeTabName = tabName;
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  displayDeleteDialog(no: number) {
    if (this.$store.state.storeIsRemoval) return;
    this.deleteRegularReportNo = no;
    this.isSensorDelete = true;
  }

  deleteReport() {
    if (!this.deleteRegularReportNo) {
      this.isSensorDelete = false;
      return;
    }
    deleteStoreReportApi({
      store_id: this.$route.params.store_id,
      setting_no: this.deleteRegularReportNo
    })
      .then(() => {
        this.isSensorDelete = false;
      })
      .catch(() => {
        alert("削除に失敗しました。");
        this.isSensorDelete = false;
      });
  }
}
